import styled from "styled-components";

export const MainWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 25px 0;
`;